import React from "react";

import { customerSurveyLabels } from "../../../../constants";

/** Fallback when the current question type is not supported. */
const UnsupportedQuestionType = () => (
  <div className="d-flex flex-column align-items-center question-container">
    <div className="my-auto">
      <h2 className="fw-bold text-center">
        {customerSurveyLabels.UNSUPPORTED_QUESTION_TYPE}
      </h2>
    </div>
  </div>
);

export default UnsupportedQuestionType;
